import { Section } from "@models/ISchema";

/**
 * Returns true when the link has at least one assigned session whose start datetime
 * is less than or equal to `scenarioNow`. Both sides are assumed to be calendar
 * strings in the scenario's timezone: intervals expose `startingDate` as
 * "YYYY-MM-DD" and sessions expose `assignment.blockRange.start.startingTime` as
 * "HH:MM:SS". `scenarioNow` is the scenario's current datetime as
 * "YYYY-MM-DD HH:MM:SS" (the `blockingThreshold.current_datetime` value).
 * Comparison is lexicographic — ISO ordering matches chronological ordering.
 */
export const isLinkStarted = (
  sections: Section[] | null | undefined,
  scenarioNow: string | null | undefined,
): boolean => {
  if (!scenarioNow || !sections?.length) return false;

  return sections.some(section =>
    section?.sessions?.some(session => {
      const startingTime = session?.assignment?.blockRange?.start?.startingTime;
      if (!startingTime) return false;

      return session?.assignment?.intervals?.some(
        interval =>
          !!interval?.startingDate && `${interval.startingDate} ${startingTime}` <= scenarioNow,
      );
    }),
  );
};
